import { createApp } from 'vue'
import App from './App.vue'
import { setupRouter } from './router'
import api from './api/auth'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import jQuery from 'jquery'
import 'bootstrap'
import 'waypoints/lib/noframework.waypoints'
import 'swiper'
import 'jquery-validation'


const app = createApp(App)


app.provide('jQuery', jQuery)

// 全局挂载API
app.config.globalProperties.$api = api

// 注册Element Plus并配置中文语言
app.use(ElementPlus, {
  locale: zhCn
})

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

setupRouter(app)
app.mount('#app')
